import { render, staticRenderFns } from "./PremiumSurveyStep.vue?vue&type=template&id=553fd49a&scoped=true"
import script from "./PremiumSurveyStep.vue?vue&type=script&lang=js"
export * from "./PremiumSurveyStep.vue?vue&type=script&lang=js"
import style0 from "./PremiumSurveyStep.vue?vue&type=style&index=0&id=553fd49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553fd49a",
  null
  
)

export default component.exports